import React from 'react';
import { Card } from '@blueprintjs/core';

import CustomDataTable from './CustomDataTable';
import ZoneSectionTableField from './ZoneSectionTableField';
import ZoneSectionBooleanField from './ZoneSectionBooleanField';
import ZoneSectionMap from './ZoneSectionMap';
import ZoneSectionMapillary from './ZoneSectionMapillary';

import styles from './ZoneDesc.module.scss';
import ZoneRadar from './ZoneRadar';
import ZoneBars from './ZoneBars';
import JobDistrib from './JobDistrib';

const radarMedians = {
  nom_ppal: 'mediane',

  surf_total: 7.9, // ha
  surfbati_tot: 7767, // m²

  taux_surfdispo_tot: 0.30,
  taux_surfbati_tot: 0.08,
  espaces_vert: 0.5,

  nb_etablissement: 9,
  nb_emplois: 52,

  color: 'silver',
};

const ZoneSection = ({ settings, ...rest }) => {
  const { Section, ShowTitle, Type, Source, Value } = settings;

  const valueArray = Value?.split(',')?.map(str => str.trim());

  const ComponentName = Type === 'Special'
    ? Source
    : Type;

  const [cleanSource, ...filters] = Source?.split('#') || [];

  return (
    <div className={styles.group}>
      {(
        Boolean(ShowTitle)
        && !['Table fields blocks', 'Table fields'].includes(ComponentName)
      ) && <h2>{Section}</h2>}

      {(ComponentName === 'Fields') && (
        <CustomDataTable fields={valueArray} {...rest} />
      )}

      {(ComponentName === 'Table fields') && (
        <ZoneSectionTableField
          title={ShowTitle && Section}
          field={cleanSource}
          headers={valueArray}
          filters={filters}
          {...rest}
        />
      )}

      {(ComponentName === 'Table fields blocks') && (
        <ZoneSectionTableField
          title={ShowTitle && Section}
          field={cleanSource}
          headers={valueArray}
          filters={filters}
          transpose
          {...rest}
        />
      )}

      {(ComponentName === 'Text') && (
        <Card>{Value}</Card>
      )}

      {(ComponentName === 'Boolean') && (
        <ZoneSectionBooleanField fields={valueArray} {...rest} />
      )}

      {(ComponentName === 'CustomMap') && (
        <ZoneSectionMap {...rest} />
      )}

      {(ComponentName === 'Mapillary') && (
        <ZoneSectionMapillary {...rest} />
      )}

      {(ComponentName === 'ZoneRadar') && (
        <ZoneRadar {...rest} median={radarMedians} />
      )}

      {(ComponentName === 'ZoneBars') && (
        <ZoneBars {...rest} />
      )}

      {(ComponentName === 'JobDistrib') && (
        <JobDistrib {...rest} />
      )}
    </div>
  );
};

export default ZoneSection;
